import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import '../src/Styles/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from '@chakra-ui/react'
import { appTheme } from './Styles/theme';
import { BrowserRouter } from "react-router-dom"

const rootElement = document.getElementById('root');
const AppTree = (
  <React.StrictMode>
    <ChakraProvider resetCSS theme={appTheme}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ChakraProvider>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, AppTree);
} else {
  createRoot(rootElement).render(AppTree);
}

reportWebVitals();
